import React, { useEffect } from "react";
import RegistrationLayout from "../../../components/Layouts/RegistrationLayout";
import { useSelector } from "react-redux";
import {
  useGetEmployeeByRoleQuery,
  useGetRegionLocationByNameQuery,
} from "../../../store/dropdown/dropdownApi";
import { useGetICByLocationQuery } from "../../../store/ic/icApi";

import { Box } from "@mui/material";

import {
  DownloadButton,
  RegistrationCard,
  RegistrationForm,
} from "../../../components";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { useGetSingleOrgQuery } from "../../../store/org/orgApi";
import { useNavigate } from "react-router-dom";
import PageHeading from "../../../components/General/PageHeading";
import RegistrationLogo from "../../../assets/logos/RegistrationLogo.svg";
import { PuneLetterDoc } from "../../../components/PDF/Registration";
import RegistrationList from "../../../utils/RegistrationList";

const Mode = [{ id: "wrwerert", name: "Courier" }];

const PuneRegistration = () => {
  const [agree, setAgree] = React.useState(false);
  const [preview, setPreview] = React.useState(false);
  const [locationValue, setLocationValue] = React.useState([]);
  const [complianceDetails, setComplianceDetails] = React.useState([]);
  const [icData, setIcData] = React.useState();
  const [letterMode, setLetterMode] = React.useState("");
  const [locationId, setLocationId] = React.useState("");
  const [representativeName, setRepresentativeName] = React.useState("");
  const [orgData, setOrgData] = React.useState();
  const [pdfPreivewLoader, setPdfPreviewLoader] = React.useState(false);

  const navigate = useNavigate();

  // Get Org-ID
  const OrganizationDetails = useSelector((state) => state.auth);
  const { user } = OrganizationDetails;

  console.log(user);
  const ID = user?.user?.org_id;
  const { data: SingleOrgData } = useGetSingleOrgQuery({ id: ID });

  // Get List of Pune's compliance manager

  const { data: puneComplianceManager } = useGetEmployeeByRoleQuery({
    role: "COMPLIANCE_MANAGER",
    org_id: ID,
  });

  // Get List of Pune's Locations
  const { data: PuneLocation } = useGetRegionLocationByNameQuery({
    region: "Pune",
    org_id: ID,
  });

  const { data: IcData } = useGetICByLocationQuery({
    location_id: locationId,
  });

  useEffect(() => {
    let temp = [];
    if (PuneLocation?.location) {
      temp = PuneLocation?.location?.map((loc) => {
        return {
          id: loc?.id,
          name: loc?.location_name,
        };
      });
    }
    setComplianceDetails(puneComplianceManager?.employees);
    setIcData(IcData?.ic?.employees);
    setOrgData({
      name: SingleOrgData?.org?.name,
      address: SingleOrgData?.org?.address_line_1,
    });
    setLocationValue(temp || []);
  }, [
    puneComplianceManager,
    PuneLocation,
    IcData,
    icData,
    complianceDetails,
    SingleOrgData,
  ]);

  const checkboxHandler = () => {
    setAgree(!agree);
    setPreview(false);
  };

  const onSubmit = (data) => {
    console.log("data", data);
    setLetterMode(data.mode);
    setLocationId(data.location);
    setRepresentativeName(data.compliance);
    setPreview(true);
    setPdfPreviewLoader(true);
    setTimeout(() => {
      setPdfPreviewLoader(false);
    }, 2000);
  };

  return (
    <RegistrationLayout>
      <PageHeading label="Pune Registration" logo={RegistrationLogo} />
      <RegistrationCard
        checkboxHandler={checkboxHandler}
        order={RegistrationList[0].pune.order}
        translatedOrder={RegistrationList[0].pune.translatedOrder}
        orderUrl={RegistrationList[0].pune.orderUrl}
        translatedOrderUrl={RegistrationList[0].pune.translatedOrderUrl}
        confirmation={RegistrationList[0].pune.confirmation}
      />
      <Box className="tw-px-60">
        <RegistrationForm
          onSubmit={onSubmit}
          complianceDetails={complianceDetails}
          locationValue={locationValue}
          Mode={Mode}
          agree={agree}
          pdfPreivewLoader={pdfPreivewLoader}
        />
        {preview && !pdfPreivewLoader && (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              marginY: "20px",
            }}
          >
            <PDFViewer
              style={{
                height: "100vh",
                width: "100%",
              }}
              onLoad={() => setPdfPreviewLoader(false)}
            >
              {letterMode === "Courier" && (
                <PuneLetterDoc
                  ICEmployee={icData}
                  representativeName={representativeName}
                  orgData={orgData}
                />
              )}
            </PDFViewer>
          </Box>
        )}

        {preview && !pdfPreivewLoader && (
          <>
            <PDFDownloadLink
              style={{ marginTop: "20px" }}
              document={
                letterMode === "Courier" && (
                  <PuneLetterDoc
                    ICEmployee={icData}
                    representativeName={representativeName}
                    orgData={orgData}
                  />
                )
              }
              fileName="PuneLetterDoc"
            >
              {({ loading }) =>
                loading ? (
                  <DownloadButton
                    loading={loading}
                    styles={{ width: "100%", marginTop: "10rem" }}
                  />
                ) : (
                  <DownloadButton
                    styles={{ width: "100%", marginTop: "10rem" }}
                  />
                )
              }
            </PDFDownloadLink>
            <DownloadButton
              label="Upload Registration"
              styles={{ width: "100%", marginTop: "2rem" }}
              onClick={() => {
                navigate("/home/upload-registration");
              }}
            />
          </>
        )}
      </Box>
    </RegistrationLayout>
  );
};

export default PuneRegistration;
